import React, { useRef, useEffect } from "react";
import Navigation from "../Components/Navigation/Navigation";
import "../Pages/Additional.css";
import Footer from "../Components/Navigation/Footer";
import Banner from "../Components/Banner";
import WhiteBuilding from "../Assets/Images/Banner/additional-services.jpg";

const Additional = () => {
  const propertySourcing = useRef(null);
  const hmoProperties = useRef(null);
  const landHomes = useRef(null);
  const propertyDevelopment = useRef(null);
  const blockManagement = useRef(null);
  const contractDrafting = useRef(null);
  const probateDivorce = useRef(null);
  const licensingRequirements = useRef(null);
  const guaranteedRent = useRef(null);
  const mortgage = useRef(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    document.title = "Additional Services | Zen Homes";
  }, []);

  return (
    <div className="additionalServicesContainer">
     <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Additional Services" backgroundImage={WhiteBuilding} />
      <div className="additionalContentContainer">
        <div className="additionalNav">
          <button onClick={() => scrollToSection(propertySourcing)}>
            Property Sourcing
          </button>
          <button onClick={() => scrollToSection(hmoProperties)}>
            HMO Properties
          </button>
          <button onClick={() => scrollToSection(landHomes)}>
            Land & New Homes
          </button>
          <button onClick={() => scrollToSection(propertyDevelopment)}>
            Property Development
          </button>
          <button onClick={() => scrollToSection(blockManagement)}>
            Block Management
          </button>
          <button onClick={() => scrollToSection(contractDrafting)}>
            Contract Drafting
          </button>
          <button onClick={() => scrollToSection(probateDivorce)}>
            Probate & Divorce Property Valuation
          </button>
          <button onClick={() => scrollToSection(licensingRequirements)}>
            Licensing & Requirements
          </button>
          <button onClick={() => scrollToSection(guaranteedRent)}>
            Guaranteed Rent
          </button>
          <button onClick={() => scrollToSection(mortgage)}>
            Mortgage & Solicitors
          </button>
        </div>

        <div className="additionalContent">
          <div ref={propertySourcing}>
            <h3>Property Sourcing</h3>
            <p>
              We aim to provide a bespoke service tailored to your needs and
              what you require for your dream home in every aspect possible. We
              will go above and beyond to ensure we can source that specific
              property for you and make every effort to meet your requirements.
              Based on the detailed description of the property you provide us
              with we will then specifically start sourcing the property for
              you, some points we would like to list in what we can offer
              subject to what you are looking for:
              <ul>
                <li>
                  <h5>Specific Roads</h5>
                  You may have had your eye on a particular road/street you
                  would like to live on, with our experienced techniques and
                  unique approach we can make this possible.
                </li>
                <br />
                <li>
                  <h5>House Style</h5>
                  Looking for what you need in a home may start from the
                  exterior look and build of the property, this may be a
                  Georgian, Victorian, Edwardian, Tudor, 1930’s, 1960’s New
                  Build, Modern, Stone Cottage, Farm, Town House., all for what
                  you maybe looking for in your new property.
                </li>
                <br />
                <li>
                  <h5>Type of House</h5>
                  This is equally important in looking for exactly what you want
                  and consists of Detached, Semi-Detached, Terrace, End of
                  Terrace, Bungalow, Cottage, Flat, Maisonette, Split Level
                  Flat, Studio Flat, Mansions, Conversion, Period, Double
                  Fronted. All these are crucial if you are specific in what you
                  want and narrowing down your search.{" "}
                </li>
                <br />
                <li>
                  <h5>Features</h5>
                  This could consist of Juliette Balcony, Bay Windows, Sash
                  Windows, Brick Fronted, Bi-Folding Doors, Landscape Garden,
                  Converted Loft/Attic Space, Sky Light, Natural Wood Flooring,
                  Bespoke Wardrobes and whatever you feel important to you in a
                  home we shall endeavor to signify.
                </li>
                <br />
                <li>
                  <h5>Area</h5>
                  We have noticed as people go through their house hunt journey,
                  they shift from area to area to find what they are looking
                  for, this is the most important part which enables us to
                  pinpoint your searchable area for us to locate the right home
                  for you. It is imperative we know from the beginning so that
                  we can ensure we find you exactly what you want for your best
                  interest.{" "}
                </li>
              </ul>
            </p>
          </div>

          <div ref={hmoProperties}>
            <h3>HMO Properties</h3>
            <p>
              We have plenty of HMO (house of multiple occupants) properties in
              our managed portfolio and have a plethora of experience in this
              field to guide, advise, to ensure you are securing the right
              income and maximizing your investment.
            </p>
            <p>
              We offer income plans and achievable current market rent for your
              properties and keep you up to date with the latest legislation and
              licensing for your property to be compliant under the current law
              and regulations, avoiding any foreseeable fines.
            </p>
          </div>
          <div ref={landHomes}>
            <h3>Land & Homes</h3>
            <p>
              We aim to secure sites and work alongside many property developers
              who are actively building New Homes and securing land that can be
              developed on. Our focus is to help developers sell their new homes
              but at the same time secure land for our investment buyers also.{" "}
            </p>
          </div>
          <div ref={propertyDevelopment}>
            <h3>Property Development</h3>
            <p>
              We can guide you in every step of the way in the construction of
              your home to maximum your return on investment and closely work
              with you, project managing the development may it be to a full
              house renovation, converting the house into individual flats, or
              looking into converting the property into a HMO we have the
              necessary knowledge to guide you through every step.
            </p>
          </div>
          <div ref={blockManagement}>
            <h3>Block Management</h3>
            <p>
              We offer a wide range of services regarding managing any small,
              medium to large blocks of flats you may have that need to be
              managed. We have teams in place who can act extremely efficiently
              to ensure your building is maintained regularly and to tackle any
              issues that may arise relating to electrical, structural,
              plumbing, general upkeep, maintenance and any small jobs that need
              urgent attention.
            </p>
          </div>
          <div ref={contractDrafting}>
            <h3>Contract Drafting</h3>
            <p>
              We draft a tenancy agreement on your behalf and liaise with the
              tenants and yourself to get the document completed.
            </p>
          </div>
          <div ref={probateDivorce}>
            <h3>Probate & Divorce Property Valuation</h3>
            <p>
              We offer our services and professional advice on cases such as
              these to ensure your property is valued in the current market
              conditions for it to be presented to various legal teams and
              processes.
            </p>
          </div>
          <div ref={licensingRequirements}>
            <h3>Licensing & Requirements</h3>
            <p>
              We are actively involved in license submissions and understand
              what is required for your property to be compliant with the
              current regulations and planning requirements.
            </p>
            <p>
              We will submit all applications on your behalf so the tedious
              process will be eliminated as we can ensure we accurately submit
              the license to avoid any refusals from the council (subject to
              necessary works being carried out to make property compliant for
              licensing){" "}
            </p>
            <p>
              Two main licenses are below:
              <ul>
                <br />
                <li>
                  Selective License – All private rented single household
                  properties within a designated area of the borough are
                  required to be licensed.
                </li>
                <br />
                <li>
                  HMO License – Include house and flat shares, student homes,
                  bedsits and some buildings converted into flats. Any
                  properties that contain three or more occupiers forming two or
                  more households who share amenities, such a kitchen, bathroom,
                  living area and any communal space require this license
                  (subject to council and borough).
                </li>
              </ul>
            </p>
          </div>
          <div ref={guaranteedRent}>
            <h3>Guaranteed Rent</h3>
            <p>
              We aim to make this process as stress free as possible in you
              receiving rent all year round, whether your property is occupied
              or vacant. You will get paid without any void periods in the
              tenancy and ensure you achieve fantastic rental yields.{" "}
            </p>
            <p>
              We will carry out monthly inspections at your property to ensure
              that your property remains at a high standard and will not be
              responsible for paying any utility bills or council tax.{" "}
            </p>
            <p>
              We can offer 2-5 years agreements/lease providing security of
              income and a stress-free lettings process in which your property
              will be managed throughout the whole duration.
            </p>
          </div>
          <div ref={mortgage}>
            <h3>Mortgage & Solicitors</h3>
            <p>
              We have a selection of mortgage brokers and solicitors that we can
              put you in touch with, assisting you with selling and purchasing a
              property who we have built strong relationships with. Their
              in-depth knowledge, experience and professional advice guiding you
              in every step of the way, so you feel comfortable and at ease with
              all related processes.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Additional;
